/**
 * API Configuration
 * CCH Care - Version 1.0
 */

// API base URL — update for each environment
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://care.clientcarehealth.org/api';

export default API_BASE_URL;
